import { request, GET, POST } from "./helper/axios"
import download from "./helper/download"

let apis = {
	// ----------------------------------------------------------------------
	gate_login: { method: POST, url: "/operator/gate/login" }, // 登录
	sysuser_user_info: { method: GET, url: "/operator/sysuser/user/info" }, // 用户详情
	display_info: { method: GET, url: "/sc/manager/display/info" }, // 餐厅相关信息

	// 今日营养
	get_StoreList: { method: GET, url: "/operator/today/product/restaurantAndStoreList" },
	get_product_list: { method: GET, url: "/operator/today/product/list" }, // 商品列表
	today_product_details: { method: GET, url: "/operator/today/product/details" }, // 商品详情
	productNourishment_pageList: { method: POST, url: "/operator/productNourishment/pageList" }, // 商品营养库列表
	productNourishment_getLibraryById: { method: GET, url: "/operator/productNourishment/getLibraryById" }, // 商品营养库详情

	// ----------------------------------------------------------------------
	// 食品安全追溯
	get_foodTraceability_list: { method: GET, url: "/operator/foodTraceability/list" }, // 商品列表
	get_foodTraceability_productNameList: { method: GET, url: "/operator/foodTraceability/productNameList" }, // 商品名称列表
	get_foodTraceability_restaurantList: { method: GET, url: "/operator/foodTraceability/restaurantList" }, // 餐厅-门店列表
	get_config_banner_list: { method: GET, url: "/operator/config/banner/list" }, // 轮播图

	// ----------------------------------------------------------------------
	// 营养科普
	popularization_list: { method: GET, url: "/sc/manager/popularization/list" },
	popularization_details: { method: GET, url: "/sc/manager/popularization/details" },

	// ----------------------------------------------------------------------
	// 失物招领
	ConvenientService_lostFind_list: { method: GET, url: "/operator/ConvenientService/lostFind/list" },

	// ----------------------------------------------------------------------
	// 其它
	config_banner_list: { method: GET, url: "/operator/config/banner/list" }, // 轮播图列表

	// 获取餐厅展屏信息
	get_display_id: { method: GET, url: '/sc/manager/display/' },
	// 获取餐厅健康证列表
	get_heath_list:{ method: POST, url: "/sc/manager/health/certificate/list" },

	// ----------------餐厅服务机-------------------
	//留样记录列表-餐厅服务机
	post_sample_scale_record_list2:{ method: POST, url: "/sc/manager/sample/scale/record/list2" },
	//巡检记录列表-服务机
	post_inspectionRecord_list:{ method: POST, url: "/sc/manager/inspectionRecord/list2" },
	//晨检记录列表-服务机
	post_record_selectList2:{ method: POST, url: "/sc/manager/record/selectList2" },


}

let api = {
	// 上传文件
	file_upload_api: (data, config = {}) => request(POST, "/file/upload", data, {
		headers: { "content-type": "application/x-www-form-urlencoded;charset=UTF-8" },
		...config,
	}),
}
for (let k in apis) {
	let a = apis[k]
	if (a.download) {
		api[k] = (data, config) => download(a.method, a.url, data, config)
	} else if (k == 'get_display_id') {
		api[k] = (path, config) => request(a.method, a.url + path, {}, config)
	} else {
		api[k] = (data, config) => request(a.method, a.url, data, config)
	}
}

export default api
